import React from 'react';


export const LocationIcon = props => {
    return (
        <svg className={props.className} width="27" height="38" viewBox="0 0 27 38" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.0348 0C5.84747 0 0 5.84747 0 13.0348C0 22.0686 13.0476 37.5 13.0476 37.5C13.0476 37.5 26.0696 21.6243 26.0696 13.0348C26.0696 5.84747 20.2224 0 13.0348 0ZM16.9677 16.8514C15.8833 17.9356 14.4592 18.4779 13.0348 18.4779C11.6107 18.4779 10.1862 17.9356 9.10217 16.8514C6.93352 14.683 6.93352 11.1546 9.10217 8.9859C10.1523 7.93533 11.5491 7.35672 13.0348 7.35672C14.5205 7.35672 15.9171 7.93556 16.9677 8.9859C19.1364 11.1546 19.1364 14.683 16.9677 16.8514Z"
                fill="#98B4DE"/>
        </svg>
    )
};
